import script from "./PbxDeviceTransportModal.vue?vue&type=script&setup=true&lang=js"
export * from "./PbxDeviceTransportModal.vue?vue&type=script&setup=true&lang=js"

import "./PbxDeviceTransportModal.vue?vue&type=style&index=0&id=71044074&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-71044074"]])

export default __exports__